import { BvModal } from "bootstrap-vue";

export const lostConnectionText =
  "The operation failed because the network connection has been lost. Please ensure that you are connected to your organization's WiFi and try again.";
export const unexpectedErrorText = "An unexpected error has occurred. Please try again.";

export function showLostConnectionModal($bvModal: BvModal) {
  return $bvModal.msgBoxOk(lostConnectionText, {
    title: "Lost Network Connection",
    hideHeaderClose: false,
    noCloseOnBackdrop: true
  });
}

export function showUnexpectedErrorModal($bvModal: BvModal) {
  return $bvModal.msgBoxOk(unexpectedErrorText, {
    title: "Unexpected Error",
    hideHeaderClose: false,
    noCloseOnBackdrop: true
  });
}

export function showRemoveAssociationModal(
  $bvModal: BvModal,
  title: string,
  removing: string,
  from: string
): Promise<boolean> {
  return $bvModal.msgBoxConfirm(`Are you sure you want to remove ${removing} from ${from}?`, {
    title: title,
    okTitle: "Remove",
    okVariant: "danger",
    cancelVariant: "light",
    noCloseOnBackdrop: true
  });
}

/**
 * Checks to see if any modal is open.
 *
 * This handles both the Vue-Bootstrap modals and the custom modals (see @/components/Modal.vue)
 * @returns true if any modals are open
 */
export function isAnyModalOpen() {
  return document.getElementsByClassName("modal-dialog").length > 0;
}
